
import { defineComponent } from 'vue';

export default defineComponent({
  mounted() {
    // this.$nextTick(function() {
    //   if (this.$slots['default']) {
    //     const slot = this.$slots['default'][0].elm as any;
    //     if (slot) {
    //       let height = slot.clientHeight;
    //       if (slot.childNodes) {
    //         const stickyContent = Array.from(slot.childNodes).find((x: any) => Array.from(x.classList).indexOf('footer-sticky-content') > -1) as any;
    //         if (stickyContent) {
    //           height = stickyContent.clientHeight;
    //         }
    //       }
    //       this.setFooterFixHeight(height);
    //     }
    //   }
    // });
  },
  unmounted() {
    //this.setFooterFixHeight(0);
  },
  methods: {
    // setFooterFixHeight(height: number) {
    //   const footerFix = document.getElementById('footer-fix');
    //   if (footerFix) {
    //     footerFix.style.height = height + 'px';
    //   }
    // },
  },
});
